import { createApp } from 'vue';
import TarBz2ToZipConverter from '@/Components/TarBz2ToZipConverter.vue';
import '@styles/app.css';

createApp(TarBz2ToZipConverter).mount('#tar-bz2-to-zip-converter');
